/**
 * BenefitCard Molecule Component
 * Icon/image + text block for showcasing benefits and advantages
 */

import React, { useState, useEffect } from "react";
import { Image } from "@/components/atoms/Image";
import { Heading } from "@/components/atoms/Heading";
import { BenefitCardBlok } from "@/types";

export interface BenefitCardProps extends BenefitCardBlok {
  className?: string;
  borderClass?: string;
}

export const BenefitCard: React.FC<BenefitCardProps> = ({
  image,
  image_light,
  title,
  className = "",
  borderClass = "",
}) => {
  const [isDark, setIsDark] = useState(() =>
    document.documentElement.classList.contains("dark"),
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDark(document.documentElement.classList.contains("dark"));
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => observer.disconnect();
  }, []);

  const imageSrc = isDark
    ? image?.filename
    : image_light?.filename || image?.filename;

  return (
    <div
      className={`relative flex flex-col gap-4 md:gap-6 lg:gap-8 justify-between ${className}`}
    >
      {/* Vertical border divider */}
      {borderClass && (
        <div className={`absolute top-0 left-0 w-0 h-[60px] ${borderClass}`} />
      )}
      {/* Content */}
      <div className="flex flex-col gap-3 md:gap-4">
        <Heading level="h3" className="text-primary text-center">
          {title}
        </Heading>
      </div>
      {image && (
        <div className="h-40 sm:h-48 md:h-64 lg:h-72 flex items-center justify-center">
          <Image
            src={imageSrc || image.filename}
            alt={image.alt || title}
            className="w-full h-full object-contain"
          />
        </div>
      )}
    </div>
  );
};

export default BenefitCard;
